export default "__VITE_ASSET__DPgYSZEo__"